import { useIntl } from '@/intl'
import { useCatalogueConfiguration, useConfiguration } from '@/scopes/common/infrastructure/config/ConfigProvider'
import { Footer } from './Footer'

export function SummerContent() {
  const intl = useIntl()
  const popularCities = useCatalogueConfiguration('summer', 'popularCities')
  const popularCountries = useCatalogueConfiguration('summer', 'popularCountries')
  const popularRegions = useCatalogueConfiguration('summer', 'popularRegions')
  const links = useConfiguration('links')

  return (
    <>
      <Footer.Block>
        <Footer.Header>{intl.formatMessage({ id: 'footer_popular_countries' })}</Footer.Header>
        <Footer.List>
          {popularCountries.map(({ text, link }) => (
            <Footer.ListItem key={text} href={link}>
              {text}
            </Footer.ListItem>
          ))}
        </Footer.List>
      </Footer.Block>
      <Footer.Block>
        <Footer.Header>{intl.formatMessage({ id: 'footer_popular_regions' })}</Footer.Header>
        <Footer.List>
          {popularRegions.map(({ text, link }) => (
            <Footer.ListItem key={text} href={link}>
              {text}
            </Footer.ListItem>
          ))}
        </Footer.List>
      </Footer.Block>
      <Footer.Block>
        <Footer.Header>{intl.formatMessage({ id: 'footer_popular_cities' })}</Footer.Header>
        <Footer.List>
          {popularCities.map(({ text, link }) => (
            <Footer.ListItem key={text} href={link}>
              {text}
            </Footer.ListItem>
          ))}
        </Footer.List>
      </Footer.Block>
      <Footer.Block>
        <Footer.Header>{intl.formatMessage({ id: 'footer_about' })}</Footer.Header>
        <Footer.List>
          <Footer.ListItem href={links.about}>{intl.formatMessage({ id: 'footer_about' })}</Footer.ListItem>
          <Footer.ListItem href={links.jobs}>{intl.formatMessage({ id: 'footer_jobs' })}</Footer.ListItem>
          <Footer.ListItem href={links.press}>{intl.formatMessage({ id: 'footer_press' })}</Footer.ListItem>
          <Footer.ListItem href={links.accessibility}>{intl.formatMessage({ id: 'footer_accessibility' })}</Footer.ListItem>
        </Footer.List>
      </Footer.Block>
      <Footer.Block>
        <Footer.Header>{intl.formatMessage({ id: 'footer_privacy_cookies' })}</Footer.Header>
        <Footer.List>
          <Footer.ListItem href={links.privacy}>{intl.formatMessage({ id: 'footer_privacy' })}</Footer.ListItem>
          <Footer.ListItem href={links.cookies}>{intl.formatMessage({ id: 'footer_cookies' })}</Footer.ListItem>
          {/* Doesn't have a link, because it should open the cookie modal (needs implementation in React) */}
          <Footer.ListItem href={links.cookiesSettings}>
            {intl.formatMessage({ id: 'footer_cookies_settings' })}
          </Footer.ListItem>
          <Footer.ListItem href={links.conditions}>{intl.formatMessage({ id: 'footer_conditions' })}</Footer.ListItem>
        </Footer.List>
      </Footer.Block>
      <Footer.Block>
        <Footer.Header>{intl.formatMessage({ id: 'footer_need_help' })}</Footer.Header>
        <Footer.List>
          <Footer.ListItem href={links.support}>{intl.formatMessage({ id: 'footer_support' })}</Footer.ListItem>
          <Footer.ListItem href={links.login}>{intl.formatMessage({ id: 'my_portal' })}</Footer.ListItem>
          <Footer.ListItem href={links.holidayGuarantee}>
            {intl.formatMessage({ id: 'footer_holiday_guarantee' })}
          </Footer.ListItem>
          <Footer.ListItem href={links.newsletter}>{intl.formatMessage({ id: 'footer_newsletter' })}</Footer.ListItem>
        </Footer.List>
      </Footer.Block>
    </>
  )
}
